const QUERY = '/mitracare-ai/database/query';

// Finish the server's read-only preparation internally; append only the final reply.
// Patient/approval choices remain genuine conversation turns. HTTP errors are never retried.
export async function completeChatAnswer(api, initial, signal) {
  let result = initial;
  for (let step = 0; step < 3; step += 1) {
    if (signal?.aborted) {
      const error = new Error('Request cancelled'); error.name = 'AbortError'; throw error;
    }
    let payload, kind;
    if (['patient_workbench', 'infection_workbench'].includes(result?.kind) && result.phase === 'review') {
      if (typeof result.query_token !== 'string' || !result.query_token || result.query_token.length > 60000) throw new Error('Invalid query reference');
      kind = result.kind;
      payload = { operation: kind === 'patient_workbench' ? 'patient_execute' : 'infection_execute', query_token: result.query_token };
    } else if (result?.kind === 'query_review') {
      if (result.plan?.operation !== 'read_query') throw new Error('Only validated read-only queries can run in chat');
      kind = 'general'; payload = result.plan;
    } else {
      return result;
    }
    const { data } = await api.post(QUERY, payload, { signal, timeout: 60000 });
    if (kind === 'general') {
      if (!Array.isArray(data?.rows) || data.applied_query?.operation !== 'read_query' || typeof data.answer !== 'string') throw new Error('Invalid business query response');
    } else if (!data?.recognized || !Array.isArray(data.rows) || typeof data.answer !== 'string' || !['results', 'choices', 'approval_choices', 'clarification', 'review'].includes(data.phase)) {
      throw new Error('Invalid chat query response');
    }
    result = { ...data, kind };
  }
  if (result?.phase === 'review' || result?.kind === 'query_review') throw new Error('The answer could not be completed. Please ask the question again.');
  return result;
}
